module.exports = __webpack_public_path__ + "static/img/Body-16.089a0cb2.jpg";